import { safeGetRecord, safeSetJSON } from '@/lib/safeStorage';

const STORAGE_KEY = 'human-rooms-ratings';

export type Rating = 'up' | 'down';

export const useRoomRatings = () => {
  const getRatings = (): Record<string, Rating> => safeGetRecord<Rating>(STORAGE_KEY);

  const rateRoom = (roomId: string, rating: Rating) => {
    const ratings = getRatings();
    ratings[roomId] = rating;
    safeSetJSON(STORAGE_KEY, ratings);
  };

  const getRating = (roomId: string): Rating | null => {
    const ratings = getRatings();
    return ratings[roomId] || null;
  };

  const getTopRatedRoomIds = (limit = 10): string[] => {
    const ratings = getRatings();
    return Object.entries(ratings)
      .filter(([, r]) => r === 'up')
      .map(([id]) => id)
      .slice(0, limit);
  };

  return { rateRoom, getRating, getRatings, getTopRatedRoomIds };
};
